<template>
    <div name="signUp">
        <content1 />
    </div>
</template>

<script>
import Content1 from '@/pages/privacy/history/SignUp0204'

export default {
    name: 'signUp',
    components: {Content1}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/privacy/SignUp.vue